import classNames from 'classnames';
import Money from 'components/generics/texts/Money';
import Typography from 'components/generics/texts/Typography';
import React, { HTMLAttributes } from 'react';
import { FinancialActivityType } from '../../types';
import classes from './index.module.scss';
import { getEventTypeProps } from 'pages/property/components/PropertyActivities/components/PropertyActivityList/components/PropertyActivityRow/utils';
import { stringOrFunction } from 'utils/helpers';

interface LandaFinancingActivityRow extends HTMLAttributes<HTMLDivElement> {
  item: FinancialActivityType;
}

const LandaFinancingActivityRow = ({
  item,
  className,
}: LandaFinancingActivityRow) => {
  const itemProps: any = getEventTypeProps(item);
  const Icon = itemProps ? itemProps.icon : '';

  return (
    <div className={classNames(classes.container, className)}>
      <div
        className={classes.circle}
        style={{ backgroundColor: itemProps?.iconBackgroundColor }}
      >
        {Icon && (
          <Icon
            className={classes.icon}
            style={{
              fill: itemProps?.iconColor,
            }}
          />
        )}
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.leftContainer}>
          <Typography className={classes.topText}>
            {itemProps?.titleLeft && itemProps?.titleLeft}
          </Typography>
          <Typography className={classes.bottomText}>
            {typeof itemProps?.subtitleLeft === 'string'
              ? itemProps.subtitleLeft
              : itemProps.subtitleLeft(item)}
          </Typography>
        </div>
        <div className={classes.rightContainer}>
          <Typography className={classes.titleRight}>
            {stringOrFunction(itemProps?.titleRight, item)}
          </Typography>
          <Typography className={classes.bottomText}>
            {itemProps?.subtitleRight(item)}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default LandaFinancingActivityRow;
